import { render, staticRenderFns } from "./Conduct.vue?vue&type=template&id=1a363c5c&scoped=true"
var script = {}
import style0 from "./Conduct.vue?vue&type=style&index=0&id=1a363c5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a363c5c",
  null
  
)

export default component.exports